import {Component, OnInit} from '@angular/core';
import {UserService} from "../../services/user.service";
import {Router} from "@angular/router";
import {NotificationsService} from "angular2-notifications";
import {AdminService} from "../../services/admin.service";

@Component({
    selector: 'app-mobilesidebar',
    templateUrl: './mobilesidebar.component.html',
    styleUrls: ['./mobilesidebar.component.css']
})
export class MobilesidebarComponent implements OnInit {
    adminList={
        name:'',
        group:''
    };
    menulist = [];
    submenlist = {};
    admindetails = {
        _id: ''
    }
    constructor(
                private adminService: AdminService,
                private notifSer: NotificationsService,
                private userService: UserService,
                private router: Router,
                ) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        }else{
            this.admindetails = this.userService.getUserDetails();
            this.getadmin();
            this.getMenu();
            this.adminService.groupupdate.subscribe(currency => {
                this.getMenu();
            })
        }
    }
    getadmin() {
        this.userService.getCustomerDetailsById(this.admindetails._id).subscribe(done => {
            this.adminList = done;
        }, (err) => {
            this.notifSer.error(
                'Error',
                'Could Not Load Admin Detail',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    getMenu() {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            this.menulist = success.menu;
            this.submenlist = success.submenu;
            localStorage.setItem('permission', this.menulist[0].permission);
        }, (error) => {
            this.notifSer.error(
                'Error',
                'Could not load menus',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }

    isUndefinedObject(obj) {
        return (typeof obj === 'undefined');
    }

}



// WEBPACK FOOTER //
// ./src/app/_layout/mobilesidebar/mobilesidebar.component.ts